/** Returns all forms in the V3 content blob. */
export function listForms(c) {
    return c.forms;
}
/**
 * Returns the form marked `isDefault`, falling back to `forms[0]`.
 * Assumes the content blob always has at least one form (V3 invariant).
 */
export function getDefaultForm(c) {
    // Non-null assertion: V3 invariant guarantees forms is non-empty.
    return (c.forms.find(f => f.isDefault) ?? c.forms[0]);
}
/** Returns the form with the given id, or `undefined` if not found. */
export function getFormContent(c, formId) {
    return c.forms.find(f => f.id === formId);
}
/**
 * Immutably upserts a form into the content blob.
 * - If a form with the same id already exists, it is replaced (via map).
 * - Otherwise the form is appended.
 * The original content object is never mutated.
 */
export function upsertFormContent(c, form) {
    const exists = c.forms.some(f => f.id === form.id);
    const forms = exists
        ? c.forms.map(f => (f.id === form.id ? form : f))
        : [...c.forms, form];
    return { ...c, forms };
}
//# sourceMappingURL=forms-accessor.js.map